import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { InsignConfirmService } from '@app/modules/insign-confirm/insign-confirm.service';
import { ActivatedRoute } from '@angular/router';
import { DRResponse, ResponseStatus } from '@app/shared/models/response';

export interface InsignParams {
    application: string;
    insignsessionid: string;
}

@Component({
    templateUrl: './insign-start.component.html',
    styleUrls: ['./insign-start.component.scss']
})
export class InsignStartComponent extends BaseComponent
                                  implements OnInit {

    protected insignParams: InsignParams;

    public alreadyCompleted: boolean;
    public sessionExpired: boolean;
    public invalidID: boolean;
    public generalError: boolean;

    get urlSuffix(): string {
        return 'session';
    }

    constructor(protected route: ActivatedRoute, protected insignConfirmService: InsignConfirmService) {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();
        this.route.queryParams.subscribe(params => {
            this.insignParams = {
                application: params['application'],
                insignsessionid: params['insignsessionid']
            };

            this.processInsignConfirm();
        });
    }

    protected processInsignConfirm(): void {
        this.insignConfirmService.processInsignConfirm({
                                      urlSuffix: this.urlSuffix,
                                      queryParams: this.insignParams
                                  })
                                  .subscribe(response => {
            this.handleResponse(response);
        }, err => {
            this.generalError = true;
        });
    }

    protected handleResponse(response: DRResponse<any>): void {
        this.handleResponseFailure(response);

        if (response.data && response.data.link) {
            window.location.href = response.data.link;
        }
    }

    protected handleResponseFailure(response: DRResponse<any>): void {
        if (response.status === ResponseStatus.FAIL) {
            if (response.additional_code === 'insign.session.closed') {
                this.alreadyCompleted = true;
            } else if (response.additional_code === 'insign.session.expired') {
                this.sessionExpired = true;
            } else if (response.additional_code === 'insign.invalid.sessionid') {
                this.invalidID = true;
            } else {
                this.generalError = true;
            }
        }
    }
}
